import React from 'react';
import useBreakpoint from 'use-breakpoint';
import { isMobile, MQ } from './Media';
import panda403Img from './img/friday-panda_403-x2.png';
import panda404Img from './img/friday-panda_404-x2.png';

import './BlockArrows.scss';
import BuyButton from './BuyButton';

const BlockArrows: React.FC = () => {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    return (
        <div className="block-arrows">
            <div className="panda-403">
                <img src={isMobile(minWidth) ? panda404Img : panda403Img} alt="" />
            </div>
            <div className="text-center button-box">
                <BuyButton />
            </div>
        </div>
    );
};

export default BlockArrows;